// Product Gallery — PDP
// Handles: variant image layer swapping, sticky card (mobile + desktop),
// slider navigation, thumbnail sync, and video pause on slide change.

// ---------------------------------------------------------------------------
// Variant image layer swap
// Called via click listener attached to every [inputvarinatimageurl] element.
// ---------------------------------------------------------------------------
function changeProductImageOnVariantVhange() {
  var attributeName = 'varinatimagelayer';
  var inputvarinatimagelayer = this.getAttribute('inputvarinatimagelayer');
  var currentSelectedVariantImg = this.getAttribute('inputvarinatimageurl');
  var selector = '[' + attributeName + '="' + inputvarinatimagelayer + '"]';
  var imageDivToChange = document.querySelectorAll(selector);
  imageDivToChange.forEach(function(imgDiv) {
    var clickedPhoto = imgDiv.getAttribute('imgurl');
    if (clickedPhoto == currentSelectedVariantImg) {
      imgDiv.classList.remove('hidden');
    } else {
      imgDiv.classList.add('hidden');
    }
  });
  document.dispatchEvent(new CustomEvent('pdp:variant-layer-changed'));
}

// ---------------------------------------------------------------------------
// Main gallery initialisation — runs after DOM is ready
// ---------------------------------------------------------------------------
window.addEventListener('DOMContentLoaded', function() {

  // ── DOM references ────────────────────────────────────────────────────────
  var product_item_gallery = document.querySelector('.product-block-list__item--gallery');
  var card = product_item_gallery.querySelector('.card');
  var galleryWrapper = document.querySelector('[data-pdp-gallery-wrapper]');
  var gallerySlider = galleryWrapper ? galleryWrapper.querySelector('[data-pdp-gallery-slider]') : null;
  var mobileGalleryControls = galleryWrapper ? galleryWrapper.querySelector('[data-pdp-gallery-controls]') : null;
  var stickyTarget = galleryWrapper || card;
  var imageSectionNewHeight = document.querySelector('.varinatImageLayer') ? document.querySelector('.varinatImageLayer').offsetWidth : null;
  var safeImageHeight = imageSectionNewHeight || (card ? card.offsetHeight : 0) || 300;
  var card__sectionHeight = document.querySelector('#card__section').offsetHeight;
  var convertImageHeight = safeImageHeight + 100;
  var placeholder_card = document.querySelector('#placeholder_card');

  // ── Helpers ───────────────────────────────────────────────────────────────

  function activeSlideHasVideo() {
    var slide = gallerySlides ? gallerySlides[activeSlideIndex] : null;
    return !!(slide && slide.querySelector('video, iframe'));
  }

  function updateMobileArrowsVisibility() {
    if (!mobileGalleryControls) return;
    if (window.innerWidth < 1000) {
      var isSticky = card && card.classList.contains('stickyProductImg');
      mobileGalleryControls.style.display = isSticky ? 'none' : 'flex';
    } else {
      mobileGalleryControls.style.display = 'flex';
    }
  }

  function updateGalleryViewportHeight() {
    if (!gallerySlider) return;
    var activeSlide = gallerySlider.querySelector('.pdp-gallery-slide.is-active');
    if (!activeSlide) return;
    var activeVariantLayer = activeSlide.querySelector('.varinatImageLayer');
    var img = activeSlide.querySelector('img.product-gallery__image');
    var imgContainer = activeSlide.querySelector('.pdp-gallery-media-image, .varinatImageLayer, .pdp-gallery-media-video');
    var newHeight = 0;
    if (activeVariantLayer) {
      newHeight = activeVariantLayer.offsetWidth || activeVariantLayer.offsetHeight;
    } else if (img && img.complete && img.naturalHeight) {
      newHeight = img.offsetHeight;
    } else if (imgContainer) {
      newHeight = imgContainer.offsetHeight;
    } else {
      newHeight = activeSlide.offsetHeight;
    }
    if (newHeight > 0) {
      gallerySlider.style.height = newHeight + 'px';
    }

    syncGalleryColumnHeight();
  }

  // slides differ in ratio, so the column has to follow the active one
  function syncGalleryColumnHeight() {
    if (!product_item_gallery || window.innerWidth < 1000) return;
    var galleryHeight = stickyTarget ? stickyTarget.offsetHeight : 0;
    product_item_gallery.style.height = Math.max(card__sectionHeight - 50, galleryHeight) + 'px';
  }

  // ── Variant image-layer click listeners ───────────────────────────────────
  var inputvarinatimageurl = document.querySelectorAll('[inputvarinatimageurl]');
  if (inputvarinatimageurl) {
    for (var i = 0; i < inputvarinatimageurl.length; i++) {
      inputvarinatimageurl[i].addEventListener('click', changeProductImageOnVariantVhange);
    }
  }

  // ── Sticky behaviour ──────────────────────────────────────────────────────
  if (window.innerWidth < 1000) {
    // Mobile: card becomes a small fixed thumbnail while scrolling through content
    var mobileStickyTarget = card;
    if (card) {
      card.style.height = safeImageHeight + 'px';
    }
    mobileStickyTarget.style.position = 'unset';
    product_item_gallery.style.height = 'auto';
    updateMobileArrowsVisibility();

    window.addEventListener('scroll', function() {
      // a video slide stays put, the sticky thumbnail lives inside slide 0 and would kill playback
      if (!activeSlideHasVideo() && window.scrollY > convertImageHeight && window.scrollY < card__sectionHeight) {
        mobileStickyTarget.classList.add('stickyProductImg');
        mobileStickyTarget.style.position = 'fixed';
        mobileStickyTarget.style.top = '85px';
        mobileStickyTarget.style.left = '5px';
        mobileStickyTarget.style.zIndex = '4';
        mobileStickyTarget.style.width = '150px';
        mobileStickyTarget.style.height = '150px';
        mobileStickyTarget.style.backgroundColor = '#F5F5F5';
        mobileStickyTarget.style.overflow = 'hidden';
        placeholder_card.style.height = safeImageHeight + 'px';
      } else {
        mobileStickyTarget.classList.remove('stickyProductImg');
        mobileStickyTarget.style.height = safeImageHeight + 'px';
        mobileStickyTarget.style.position = 'unset';
        mobileStickyTarget.style.top = '';
        mobileStickyTarget.style.left = '';
        mobileStickyTarget.style.zIndex = '';
        mobileStickyTarget.style.width = '100%';
        mobileStickyTarget.style.borderRadius = '';
        mobileStickyTarget.style.backgroundColor = '';
        mobileStickyTarget.style.overflow = '';
        placeholder_card.style.height = '0px';
      }
      updateMobileArrowsVisibility();
    });

  } else {
    // Desktop: gallery wrapper is position: sticky
    function makeImageStickyDesktop() {
      var firstVariantLayer = document.querySelector('.varinatImageLayer');
      var currentImageSectionHeight = firstVariantLayer ? firstVariantLayer.offsetWidth : imageSectionNewHeight;
      if (card && currentImageSectionHeight) {
        card.style.height = currentImageSectionHeight + 'px';
      }
      updateGalleryViewportHeight();
      syncGalleryColumnHeight();
      stickyTarget.style.position = 'sticky';
      stickyTarget.style.top = '120px';
    }
    makeImageStickyDesktop();

    window.addEventListener('resize', function() {
      updateGalleryViewportHeight();
      makeImageStickyDesktop();
      updateMobileArrowsVisibility();
    });
  }

  // ── Slider state ──────────────────────────────────────────────────────────
  var gallerySlides = galleryWrapper ? galleryWrapper.querySelectorAll('[data-pdp-gallery-slide]') : [];
  var galleryThumbs = galleryWrapper ? galleryWrapper.querySelectorAll('[data-pdp-gallery-thumb]') : [];
  var prevButton = galleryWrapper ? galleryWrapper.querySelector('[data-pdp-gallery-prev]') : null;
  var nextButton = galleryWrapper ? galleryWrapper.querySelector('[data-pdp-gallery-next]') : null;
  var thumbPrevButton = galleryWrapper ? galleryWrapper.querySelector('[data-pdp-gallery-thumb-prev]') : null;
  var thumbNextButton = galleryWrapper ? galleryWrapper.querySelector('[data-pdp-gallery-thumb-next]') : null;
  var activeSlideIndex = 0;

  // ── Thumbnail 0 sync (configurator card clone) ────────────────────────────
  function syncFirstThumbFromCard() {
    if (!galleryWrapper) return;
    var firstThumb = galleryWrapper.querySelector('[data-pdp-gallery-thumb][data-thumb-index="0"]');
    if (!firstThumb || !card) return;

    var cardClone = card.cloneNode(true);
    cardClone.classList.add('pdp-gallery-thumb__card-preview');

    cardClone.querySelectorAll('.varinatImageLayer.hidden').forEach(function(layer) {
      layer.remove();
    });

    var cardCloneImage = cardClone.querySelector('img');
    if (cardCloneImage) {
      cardCloneImage.classList.remove('product-gallery__image');
      cardCloneImage.classList.add('pdp-gallery-thumb__image');
      cardCloneImage.removeAttribute('data-zoom');
      cardCloneImage.removeAttribute('data-zoom-width');
    }

    firstThumb.innerHTML = '';
    firstThumb.appendChild(cardClone);
  }

  // ── showSlide ─────────────────────────────────────────────────────────────
  function showSlide(index) {
    if (!gallerySlides.length) return;
    if (index < 0) index = 0;
    if (index > gallerySlides.length - 1) index = gallerySlides.length - 1;
    activeSlideIndex = index;

    gallerySlides.forEach(function(slide, slideIndex) {
      if (slideIndex === activeSlideIndex) {
        slide.classList.remove('pdp-gallery-slide--hidden');
        slide.classList.add('is-active');
      } else {
        slide.classList.add('pdp-gallery-slide--hidden');
        slide.classList.remove('is-active');
        // Pause native video when navigating away
        var video = slide.querySelector('video');
        if (video) video.pause();
      }
    });

    var activeSlide = gallerySlides[activeSlideIndex];
    var img = activeSlide.querySelector('img.product-gallery__image');
    if (img && !img.complete) {
      img.onload = function() { updateGalleryViewportHeight(); };
    } else {
      updateGalleryViewportHeight();
    }

    galleryThumbs.forEach(function(thumb, thumbIndex) {
      thumb.classList.toggle('is-active', thumbIndex === activeSlideIndex);
    });

    if (galleryThumbs[activeSlideIndex]) {
      galleryThumbs[activeSlideIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    if (prevButton)      prevButton.disabled      = activeSlideIndex === 0;
    if (nextButton)      nextButton.disabled      = activeSlideIndex === gallerySlides.length - 1;
    if (thumbPrevButton) thumbPrevButton.disabled = activeSlideIndex === 0;
    if (thumbNextButton) thumbNextButton.disabled = activeSlideIndex === gallerySlides.length - 1;

    updateGalleryViewportHeight();
  }

  // ── Navigation listeners ──────────────────────────────────────────────────
  if (gallerySlides.length > 1) {
    if (prevButton)      prevButton.addEventListener('click',      function() { showSlide(activeSlideIndex - 1); });
    if (nextButton)      nextButton.addEventListener('click',      function() { showSlide(activeSlideIndex + 1); });
    if (thumbPrevButton) thumbPrevButton.addEventListener('click', function() { showSlide(activeSlideIndex - 1); });
    if (thumbNextButton) thumbNextButton.addEventListener('click', function() { showSlide(activeSlideIndex + 1); });

    galleryThumbs.forEach(function(thumb, thumbIndex) {
      thumb.addEventListener('click', function() { showSlide(thumbIndex); });
    });
  } else {
    if (galleryWrapper) {
      var galleryControls   = galleryWrapper.querySelector('[data-pdp-gallery-controls]');
      var galleryThumbnails = galleryWrapper.querySelector('[data-pdp-gallery-thumbnails-wrapper]');
      if (galleryControls)   galleryControls.style.display   = 'none';
      if (galleryThumbnails) galleryThumbnails.style.display = 'none';
    }
  }

  // ── Video play overlay ────────────────────────────────────────────────────
  // Native controls stay off until the visitor starts the clip, so a video slide
  // reads as a video and not as an image with a progress bar.
  function initVideoPlayButtons() {
    if (!galleryWrapper) return;
    var playButtons = galleryWrapper.querySelectorAll('[data-pdp-gallery-play]');

    playButtons.forEach(function(playButton) {
      var mediaBox = playButton.parentElement;
      var video = mediaBox ? mediaBox.querySelector('video') : null;
      if (!video) return;

      playButton.addEventListener('click', function() {
        playButton.classList.add('is-hidden');
        video.controls = true;
        video.play();
      });

      video.addEventListener('ended', function() {
        if (video.loop) return;
        video.controls = false;
        video.load(); // brings the poster back so the clip can be started again
        playButton.classList.remove('is-hidden');
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  syncFirstThumbFromCard();
  initVideoPlayButtons();

  document.addEventListener('pdp:variant-layer-changed', function() {
    if (activeSlideIndex !== 0) showSlide(0);
    syncFirstThumbFromCard();
  });

  showSlide(0);
  updateMobileArrowsVisibility();

});

// ── Tab navigation (desktop + mobile) ─────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    var tabsNav = document.getElementById('pdp-category-tabs');
    if (!tabsNav) return;
    var tabBtns = tabsNav.querySelectorAll('.pdp-category-tab-btn');
    var tabPanels = document.querySelectorAll('.pdp-tab-panel');

    function activateTab(tabKey) {
      tabBtns.forEach(function(btn) {
        btn.classList.toggle('is-active', btn.dataset.tab === tabKey);
      });
      tabPanels.forEach(function(panel) {
        panel.classList.toggle('is-active', panel.dataset.tab === tabKey);
      });
    }

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        activateTab(btn.dataset.tab);
      });
    });

    if (tabBtns.length > 0) {
      activateTab(tabBtns[0].dataset.tab);
    }
  });

  // function to handle if there's sub variant inside one variant to be checked the first sub variant with on click
  document.addEventListener('DOMContentLoaded', function () {
    var sub_variants = document.querySelectorAll(`[hasSubVariant="true"]`);
     if (!sub_variants) return;
    if (sub_variants) {
      sub_variants.forEach((variant) => {
        function handleClick() {
          var variantLabel = variant.nextElementSibling;
          // Check if the next element is a LABEL
          if (variantLabel && variantLabel.tagName === 'LABEL') {
            var first_sub_variant = variantLabel.querySelector('input');
            if (first_sub_variant) {
              first_sub_variant.checked = true;
            }
          }
        }
        variant.addEventListener('click', handleClick);
      });
    }
  });

// ── Sticky category tabs (clone approach) ─────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  var tabsNav = document.getElementById('pdp-category-tabs');
  if (!tabsNav) return;

  // The card that contains the product info — stop showing clone once scrolled past
  var cardSection = document.querySelector('.card.card--collapsed.card--sticky');

  // Read the live header height from the CSS variable set by updateHeaderMetrics().
  function getHeaderOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(raw) || 0;
  }

  // Mirror the exact same logic used by header.liquid:
  // header__inner hides when scrolling DOWN past the isScrollAnimation threshold.
  // isScrollAnimation is a page-level var set in header.liquid (default 50).
  var _tabLastScrollY = window.pageYOffset;
  var _headerHidden = false;

  window.addEventListener('scroll', function () {
    var currentY = window.pageYOffset;
    var threshold = (typeof isScrollAnimation !== 'undefined') ? isScrollAnimation : 50;
    if (currentY > _tabLastScrollY) {
      // downscroll
      if (currentY > threshold) _headerHidden = true;
    } else {
      // upscroll — header always comes back
      _headerHidden = false;
      // Immediately restore headerWrapper pointer events so the header is clickable again
      var headerWrapper = document.querySelector('.headerWrapper');
      if (headerWrapper) headerWrapper.style.pointerEvents = '';
    }
    _tabLastScrollY = currentY <= 0 ? 0 : currentY;
  }, { passive: true });

  function isHeaderInnerHidden() {
    return _headerHidden;
  }

  // ── Build the clone ────────────────────────────────────────────────────
  var stickyClone = tabsNav.cloneNode(true);
  stickyClone.removeAttribute('id');                  // avoid duplicate IDs
  stickyClone.setAttribute('aria-hidden', 'true');    // decorative copy
  stickyClone.style.cssText = [
    'position: fixed',
    'left: ' + tabsNav.getBoundingClientRect().left + 'px',
    'width: ' + tabsNav.offsetWidth + 'px',
    'z-index: 4',
    'background: var(--background)',
    'opacity: 0',
    'pointer-events: none',
    'transition: opacity 0.25s ease, top 0.25s ease',
    'top: 0px',
    'padding-bottom: 10px',
    'box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.08)'
  ].join(';');

  document.body.appendChild(stickyClone);

  // Keep clone button clicks in sync with the real nav
  var cloneBtns = stickyClone.querySelectorAll('.pdp-category-tab-btn');
  cloneBtns.forEach(function (cloneBtn) {
    cloneBtn.addEventListener('click', function () {
      var tab = cloneBtn.dataset.tab;
      var realBtn = tabsNav.querySelector('[data-tab="' + tab + '"]');
      if (realBtn) realBtn.click();
    });
  });

  // Keep clone active state in sync whenever the real nav changes
  function syncCloneActiveState() {
    var realBtns = tabsNav.querySelectorAll('.pdp-category-tab-btn');
    realBtns.forEach(function (realBtn, i) {
      if (cloneBtns[i]) {
        cloneBtns[i].classList.toggle('is-active', realBtn.classList.contains('is-active'));
      }
    });
  }

  // Observe class changes on real buttons to keep clone in sync
  tabsNav.querySelectorAll('.pdp-category-tab-btn').forEach(function (btn) {
    new MutationObserver(syncCloneActiveState).observe(btn, { attributes: true, attributeFilter: ['class'] });
  });

  // ── Show / hide the clone ──────────────────────────────────────────────
  var originalTop = tabsNav.getBoundingClientRect().top + window.pageYOffset;
  var isVisible = false;

  function applyCloneTop() {
    stickyClone.style.top = isHeaderInnerHidden() ? '0px' : getHeaderOffset() + 'px';
  }

  function showClone() {
    if (!isVisible) {
      isVisible = true;
      stickyClone.style.pointerEvents = '';
      syncCloneActiveState();
    }
    applyCloneTop();
    stickyClone.style.opacity = '1';
    // Hide the original nav so both are never visible at the same time
    tabsNav.style.visibility = 'hidden';
    tabsNav.style.opacity = '0';
    // Block clicks through invisible header wrapper when header is hidden
    var headerWrapper = document.querySelector('.headerWrapper');
    if (isHeaderInnerHidden() && headerWrapper) headerWrapper.style.pointerEvents = 'none';
  }

  function hideClone() {
    if (!isVisible) return;
    isVisible = false;
    stickyClone.style.opacity = '0';
    stickyClone.style.pointerEvents = 'none';
    // Restore the original nav
    tabsNav.style.visibility = '';
    tabsNav.style.opacity = '';
    var headerWrapper = document.querySelector('.headerWrapper');
    if (headerWrapper) headerWrapper.style.pointerEvents = '';
  }

  function updateStickyClone() {
    var scrollY = window.pageYOffset;
    var headerOffset = getHeaderOffset();
    var stickyStart = originalTop - headerOffset;

    var stickyEnd = Infinity;
    if (cardSection) {
      var cardRect = cardSection.getBoundingClientRect();
      stickyEnd = scrollY + cardRect.bottom;
    }

    
    if (scrollY > stickyStart && scrollY < stickyEnd - 600) {

      showClone();
    } else {

      hideClone();
    }
  }

  // ── Keep clone width/left in sync on resize ────────────────────────────
  window.addEventListener('resize', function () {
    var rect = tabsNav.getBoundingClientRect();
    stickyClone.style.left = rect.left + 'px';
    stickyClone.style.width = tabsNav.offsetWidth + 'px';
    originalTop = rect.top + window.pageYOffset;
    updateStickyClone();
  });

  window.addEventListener('scroll', updateStickyClone, { passive: true });
});
